import { useMutation, useQuery, useQueryClient } from 'react-query';
import { setAccountId, getSelectedAccountId } from '~/api/routes/auth/user';

export function useAccountQuery() {
  const queryClient = useQueryClient();

  const accountQuery = useQuery('account_id', getSelectedAccountId);
  const { mutate } = useMutation(setAccountId, {
    onMutate: async id => {
      await queryClient.cancelQueries('account_id');

      const previousId = queryClient.getQueryData('account_id');

      queryClient.setQueryData('account_id', id);

      return { previousId };
    },
    onError: (_data, _error, context: { previousId: string | null }) => {
      queryClient.setQueryData('account_id', context.previousId);
    },
    onSettled: () => {
      queryClient.invalidateQueries('account_id');
    },
  });

  const { data } = accountQuery;

  return [data, mutate, accountQuery];
}
